export const API_URL = `https://dashapi.syriaone.tv`;
export const CLOUD_URL = `https://cloud.syriaone.tv/Storage`;
export const UPLOAD_URL = `https://upload.syriaone.tv/UploadImage`;

export const USERS_URL = `${API_URL}/Users`;
export const ARTICLES_URL = `${API_URL}/Articles`;
export const CATEGORIES_URL = `${API_URL}/Categories`;
export const STATIC_URL = `${API_URL}/Static`;
